<div class="sg2-treeview-toolbar">

  <!--
  <button mat-icon-button [matMenuTriggerFor]="treemenu">
    <mat-icon>more_vert</mat-icon>
  </button>
  <mat-menu #treemenu="matMenu">
    <button mat-menu-item (click)="nodeMenuClickHandler('add', {})">
      <mat-icon>add</mat-icon>
      <span>{{'addmodule' | translate }}</span>
    </button>
  </mat-menu>
  -->

  <mat-form-field class="sg2-treeview-search">
    <input matInput (keyup)="applyFilter()" (change)="applyFilter()" placeholder="Zoek" [(ngModel)]="query">
    <mat-icon matSuffix class="sg2-treeview-search-clear" *ngIf="query" (click)="clearFilter()">clear</mat-icon>
  </mat-form-field>

  <button mat-icon-button [matMenuTriggerFor]="menu" *ngIf="selectable">
    <mat-icon>filter_list</mat-icon>
  </button>
  <mat-menu #menu="matMenu">
    <button mat-menu-item (click)="setShowSelected(null)">
      <mat-icon *ngIf="showSelected === null">check_circle</mat-icon>
      <mat-icon *ngIf="showSelected !== null">radio_button_unchecked</mat-icon>
      <span>{{'showspecification' | translate: 'plural'}}</span>
    </button>
    <button mat-menu-item (click)="setShowSelected(true)">
      <mat-icon *ngIf="showSelected === true">check_circle</mat-icon>
      <mat-icon *ngIf="showSelected !== true">radio_button_unchecked</mat-icon>
      <span>{{'showselectedspecification' | translate: 'plural'}}</span>
    </button>
    <button mat-menu-item (click)="setShowSelected(false)">
      <mat-icon *ngIf="showSelected === false">check_circle</mat-icon>
      <mat-icon *ngIf="showSelected !== false">radio_button_unchecked</mat-icon>
      <span>{{'showdeselectedspecification' | translate: 'plural'}}</span>
    </button>
  </mat-menu>

  <mat-menu #nodeMenu="matMenu">
    <ng-template matMenuContent let-node="node">
      <button mat-menu-item (click)="nodeMenuClickHandler('rename', node)">
        <mat-icon>edit</mat-icon>
        <span>{{'rename' | translate: 'plural'}}</span>
      </button>
      <button mat-menu-item (click)="nodeMenuClickHandler('delete', node)">
        <mat-icon>delete</mat-icon>
        <span>{{'delete' | translate: 'plural'}}</span>
      </button>
    </ng-template>
  </mat-menu>

  <button mat-icon-button (click)="toggleExpandAll(true)" *ngIf="showExpandMore === true">
    <mat-icon>unfold_more</mat-icon>
  </button>

  <button mat-icon-button (click)="toggleExpandAll(false)" *ngIf="showExpandMore === false">
    <mat-icon>unfold_less</mat-icon>
  </button>
</div>

<!-- Modules -->
<div class="sg2-treeview-main-content">
  <ul class="sg2-treeview-node-root" [ngClass]="{'dragging': dragging}" cdkDropList
      (cdkDropListDropped)="drop(treenodes, $event)">
    <ng-container *ngFor="let node of treenodes">
      <li cdkDrag
          [cdkDragDisabled]="!orderable"
          cdkDragLockAxis="y"
          [ngClass]="{'draggable': orderable, 'filtered-node': node.filtered}"
          (cdkDragStarted)="dragStarted($event)"
          (cdkDragEnded)="dragEnded($event)"
          *ngIf="showSelected === null || node.selected === showSelected">

    <span id="treeview-ref-{{node.ref}}" class="label node-node"
          [ngClass]="{'marked-node': node.marked, 'clickable': parentClickable}">
      <mat-icon cdkDragHandle class="drag-indicator" [ngClass]="{'no-drag-options': treenodes.length < 2}"
        *ngIf="authService.canUpdate('module')">drag_indicator</mat-icon>
      <button (click)="nodeClickHandler(node)" class="option-menu-container" *ngIf="authService.canUpdate('module') && showOptions" mat-icon-button
              [matMenuTriggerFor]="nodeMenu" [matMenuTriggerData]="{node: node}">
        <mat-icon>more_vert</mat-icon>
      </button>
      <span class="sg2-treeview-toggle-container" (click)="toggleExpand(node)">
        <mat-icon class="sg2-treeview-toggle-expand">{{node.expanded ? 'expand_more' : 'chevron_right'}}</mat-icon>
      </span>
      <mat-checkbox [indeterminate]="node.selected !== false && node.selected !== true"
                    (change)="checkboxClickHandler(node)" *ngIf="selectable" [(ngModel)]="node.selected"
                    class="sg2-treeview-checkbox"></mat-checkbox>

      <span *ngIf="showChapter && node.chapter" (click)="nodeClickHandler(node)" class="sg2-treeview-node-chapter">
                  {{node.chapter}}
                </span>
      <span (click)="parentClickable && nodeClickHandler(node)" class="sg2-treeview-node-name"
            [innerHTML]="node.name | highlight:query"></span>
    </span>

        <!-- Submodules -->
        <ul *ngIf="node.children && node.expanded && !node.filtered" class="sg2-treeview-node-child" cdkDropList
            (cdkDropListDropped)="drop(node.children, $event)">
          <ng-container *ngFor="let child of node.children">
            <li cdkDrag
                [cdkDragDisabled]="!orderable"
                cdkDragLockAxis="y"
                [ngClass]="{'draggable': orderable}"
                (cdkDragStarted)="dragStarted($event)"
                (cdkDragEnded)="dragEnded($event)"
                *ngIf="showSelected === null || child.selected === showSelected">


            <span id="treeview-ref-{{child.ref}}" class="label node-child"
                  [ngClass]="{'marked-node': child.marked, 'clickable': parentClickable}">
              <mat-icon cdkDragHandle class="drag-indicator" [ngClass]="{'no-drag-options': node.children.length < 2}"
                *ngIf="authService.canUpdate('submodule')">drag_indicator</mat-icon>
              <button (click)="nodeClickHandler(child)" class="option-menu-container" *ngIf="authService.canUpdate('submodule') && showOptions"
                      mat-icon-button [matMenuTriggerFor]="nodeMenu" [matMenuTriggerData]="{node: child}">
                <mat-icon>more_vert</mat-icon>
              </button>
              <span class="sg2-treeview-toggle-container" (click)="toggleExpand(child)">
                <mat-icon
                  class="sg2-treeview-toggle-expand">{{child.expanded ? 'expand_more' : 'chevron_right'}}</mat-icon>
              </span>
              <mat-checkbox [indeterminate]="child.selected !== false && child.selected !== true"
                            (change)="checkboxClickHandler(child)" *ngIf="selectable" [(ngModel)]="child.selected"
                            class="sg2-treeview-checkbox"></mat-checkbox>
              <span *ngIf="showChapter && child.chapter" (click)="nodeClickHandler(child)"
                    class="sg2-treeview-node-chapter">
                  {{child.chapter}}
                </span>
              <span (click)="parentClickable && nodeClickHandler(child)" class="sg2-treeview-node-name"
                    [innerHTML]="child.name | highlight:query"></span>
            </span>

              <!-- Elements -->
              <ul *ngIf="child.children && child.expanded" class="sg2-treeview-node-grandchild" cdkDropList
                  (cdkDropListDropped)="drop(child.children, $event)">
                <ng-container *ngFor="let grandchild of child.children">
                  <li cdkDrag
                      [cdkDragDisabled]="!orderable"
                      cdkDragLockAxis="y"
                      [ngClass]="{'draggable': orderable}"
                      (cdkDragStarted)="dragStarted($event)"
                      (cdkDragEnded)="dragEnded($event)"
                      *ngIf="showSelected === null || grandchild.selected === showSelected">


                  <span id="treeview-ref-{{grandchild.ref}}" class="label node-grandchild clickable"
                        [ngClass]="{'marked-node': grandchild.marked}">
                    <mat-icon cdkDragHandle class="drag-indicator" *ngIf="authService.canUpdate('element')"
                              [ngClass]="{'no-drag-options': child.children.length < 2}">drag_indicator</mat-icon>
                    <button (click)="nodeClickHandler(grandchild)" class="option-menu-container" *ngIf="authService.canUpdate('element') && showOptions"
                            mat-icon-button
                            [matMenuTriggerFor]="nodeMenu" [matMenuTriggerData]="{node: grandchild}">
                      <mat-icon>more_vert</mat-icon>
                    </button>
                    <mat-checkbox (change)="checkboxClickHandler(grandchild)" *ngIf="selectable"
                                  [(ngModel)]="grandchild.selected" class="sg2-treeview-checkbox"></mat-checkbox>

                    <span *ngIf="showChapter && grandchild.chapter" (click)="nodeClickHandler(grandchild)"
                          class="sg2-treeview-node-chapter">
                      {{grandchild.chapter}}
                    </span>
                    <a href="#" data-toggle="tooltip" title="{{ grandchild.name }}">
                      <span matBadge="22" matBadgePosition="above after" (click)="nodeClickHandler(grandchild)"
                            class="sg2-treeview-node-name"
                            [innerHTML]="grandchild.label | highlight:query">
                      </span>
                      </a>
                  </span>
                  </li>
                </ng-container>
              </ul>

            </li>
          </ng-container>

        </ul>
      </li>
    </ng-container>
  </ul>
</div>
